module.exports = __webpack_public_path__ + "img/logo-header.4c24c13d.png";